"use client";
import { Clipboard, IconButton, Tokens } from "@chakra-ui/react";

interface GenericCopyClipboardProps {
  stringToCopy: string;
  iconSize?: Tokens["fontSizes"];
}

export default function GenericCopyClipboard({
  stringToCopy,
  iconSize = "xs",
}: GenericCopyClipboardProps) {
  return (
    <Clipboard.Root value={stringToCopy}>
      <Clipboard.Trigger asChild>
        <IconButton
          //
          variant="ghost"
          fontSize={iconSize}
        >
          <Clipboard.Indicator />
        </IconButton>
      </Clipboard.Trigger>
    </Clipboard.Root>
  );
}
